import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import { gapi } from "gapi-script";

const MySwal = withReactContent(Swal2);

const SendSellClientMail = (props) => {
  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState("");
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [status, setStatus] = useState([]);
  const [sellFiles, setSellFiles] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [inputs, setInputs] = useState({});

  const changeFiles = (e) => {
    if (e.target.files.length > 8) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Możesz dodać maksymalnie 8 załączników",
      });
    } else {
      setUploadFiles([]);
      setUploadFilesArray([]);
      setUploadFilesNamesArray([]);

      setUploadFiles(e.target.files);
      setUploadFilesArray(Array.from(e.target.files));
      var arr = [];
      Array.from(e.target.files).map((el, index) => {
        arr.push({ id: index, name: el.name });
      });
      setUploadFilesNamesArray(arr);
    }
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const fetchTemplates = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellMailTemplates", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
        fetchFiles();
      })
      .catch((error) => {});
  };

  const fetchFiles = async () => {
    var body = {
      leadId: props.leadData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellFilesLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellFiles(data);
        fetchAnalysis();
      })
      .catch((error) => {});
  };

  const fetchAnalysis = async () => {
    var body = {
      leadId: props.leadData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getAnalysis", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAnalysis(data);
        fetchSellStatus();
      })
      .catch((error) => {});
  };

  const fetchSellStatus = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setStatus(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTemplates();
  };

  useEffect(() => {
    getData();
  }, []);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["link"],
    ],
  };

  const handleTemplateChange = (e) => {
    setTemplate(e.target.value);
    var content = templates
      .filter((el) => +el.id === +e.target.value)[0]
      .content.replaceAll(
        "{{link}}",
        "https://workflow.kppp.pl/?clientUpload=1&client=" + props.leadData.id
      )
      .replaceAll(
        "{{linkSKD}}",
        "https://workflow.kppp.pl/?clientSKDUpload=1&client=" +
          props.leadData.id
      )
      .replaceAll("{{phone}}", props.leadData.phone)
      .replaceAll("{{phoneUser}}", props.uData.phone)
      .replaceAll("{{user_name}}", props.uData.name);
    var subject = templates.filter((el) => +el.id === +e.target.value)[0]
      .subject;
    setValue(content);
    setSubject(subject);
  };

  const addClientContact = async () => {
    var body = {
      type: "Mailowy",
      content: value.replaceAll(/(<([^>]+)>)/gi, " "),
      date: new Date(),
      leadId: props.leadData.id,
      user: props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    props.logClientAction("Dodano kontakt z klientem", props.leadData.id);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const setStatusX = () => {
    if (props.mode === "sellTask") {
      sendMail();
      return;
    }
    var model = [];

    status.map((el) => {
      if (el.status !== "oznaczono do zamknięcia") {
        model[el.status] = el.status;
      }
    });

    if (props.uData.role === "consultantTele") {
      sendMail();
    } else {
      MySwal.fire({
        title: "Proszę o wskazanie bieżącego statusu zgłoszenia",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz status",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać status");
            }
          });
        },
      }).then(async function (result) {
        if (result.isConfirmed) {
          var res = result.value;

          var body = {
            leadId: props.leadData.id,
            value: res,
            reason: "",
          };

          fetch("https://apidevkppp.ftpeople.pl/updateLeadStatus", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then((data) => {
              sendMail();
            })
            .catch((error) => {});
        } else {
          sendMail();
        }
      });
    }
  };

  const sendMail = async () => {
    try {
      if (uploadFilesArray.length > 8) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Możesz dodać maksymalnie 8 załączników",
        });
      } else {
        if (template) {
          setLoading(true);
          props.logClientAction(
            "Wysłano mail: " + "'" + subject + "'",
            props.leadData.id
          );
          var length = uploadFilesArray.length;
          var progr = 0;
          if (length > 0) {
            uploadFilesArray.map(async (file) => {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", "mail");
              formData.append("leadId", props.leadData.id);
              formData.append("user", props.userName);

              await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
                method: "POST",
                body: formData,
              })
                .then((response) => {})
                .then((responseJson) => {
                  ++progr;
                  MySwal.fire({
                    icon: "success",
                    title: "Wysłano plik: " + progr + "/" + length,
                    text: "",
                  }).then(async (result) => {
                    if (progr === length) {
                      emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                      var templateParams = {
                        to: props.leadData.mail.split(",")[0],
                        //to: "adriantomys@gmail.com",
                        reply_to: props.uData
                          ? props.uData.mail
                          : props.userMail,
                        content: value,
                        subject: subject,
                        user_name:
                          props.uData.role === "consultantTele"
                            ? "Kancelaria Radcy Prawnego Mateusz Płudowski"
                            : props.userName,
                        user_phone: props.uData ? props.uData.phone : "",
                        file1:
                          uploadFilesArray.length > 0
                            ? await toBase64(uploadFilesArray[0])
                            : "",
                        file1_name:
                          uploadFilesArray.length > 0
                            ? uploadFilesArray[0].name
                            : "",
                        file2:
                          uploadFilesArray.length > 1
                            ? await toBase64(uploadFilesArray[1])
                            : "",
                        file2_name:
                          uploadFilesArray.length > 1
                            ? uploadFilesArray[1].name
                            : "",
                        file3:
                          uploadFilesArray.length > 2
                            ? await toBase64(uploadFilesArray[2])
                            : "",
                        file3_name:
                          uploadFilesArray.length > 2
                            ? uploadFilesArray[2].name
                            : "",
                        file4:
                          uploadFilesArray.length > 3
                            ? await toBase64(uploadFilesArray[3])
                            : "",
                        file4_name:
                          uploadFilesArray.length > 3
                            ? uploadFilesArray[3].name
                            : "",
                        file5:
                          uploadFilesArray.length > 4
                            ? await toBase64(uploadFilesArray[4])
                            : "",
                        file5_name:
                          uploadFilesArray.length > 4
                            ? uploadFilesArray[4].name
                            : "",
                        file6:
                          uploadFilesArray.length > 5
                            ? await toBase64(uploadFilesArray[5])
                            : "",
                        file6_name:
                          uploadFilesArray.length > 5
                            ? uploadFilesArray[5].name
                            : "",
                        file7:
                          uploadFilesArray.length > 6
                            ? await toBase64(uploadFilesArray[6])
                            : "",
                        file7_name:
                          uploadFilesArray.length > 6
                            ? uploadFilesArray[6].name
                            : "",
                        file8:
                          uploadFilesArray.length > 7
                            ? await toBase64(uploadFilesArray[7])
                            : "",
                        file8_name:
                          uploadFilesArray.length > 7
                            ? uploadFilesArray[7].name
                            : "",
                      };

                      addClientContact();

                      var service = "";
                      if (props.uData.role === "consultantTele") {
                        service = "analizy_kppp";
                      } else {
                        service = "KPPP";
                      }

                      emailjs
                        .send(service, "template_h43760d", templateParams)
                        .then(
                          function (response) {
                            if (props.mode === "sellTask") {
                              props.close();
                            } else {
                              MySwal.fire({
                                icon: "success",
                                title: "Wysłano",
                                text: "wiadomość do klienta",
                              }).then(async (result) => {
                                props.close();
                              });
                            }
                          },
                          function (error) {
                            MySwal.fire({
                              icon: "error",
                              title: "Błąd",
                              text: "nie wysłano wiadomości e-mail. Ponów operację!",
                            }).then(async (result) => {
                              props.close();
                            });
                          }
                        );
                    }
                  });
                });
            });
          } else {
            emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
            var templateParams = {
              to: props.leadData.mail.split(",")[0],
              //to: "adriantomys@gmail.com",
              reply_to: props.uData ? props.uData.mail : props.userMail,
              content: value,
              subject: subject,
              user_name:
                props.uData.role === "consultantTele"
                  ? "Kancelaria Radcy Prawnego Mateusz Płudowski"
                  : props.userName,
              user_phone: props.uData ? props.uData.phone : "",
              file1:
                uploadFilesArray.length > 0
                  ? await toBase64(uploadFilesArray[0])
                  : "",
              file1_name:
                uploadFilesArray.length > 0 ? uploadFilesArray[0].name : "",
              file2:
                uploadFilesArray.length > 1
                  ? await toBase64(uploadFilesArray[1])
                  : "",
              file2_name:
                uploadFilesArray.length > 1 ? uploadFilesArray[1].name : "",
              file3:
                uploadFilesArray.length > 2
                  ? await toBase64(uploadFilesArray[2])
                  : "",
              file3_name:
                uploadFilesArray.length > 2 ? uploadFilesArray[2].name : "",
              file4:
                uploadFilesArray.length > 3
                  ? await toBase64(uploadFilesArray[3])
                  : "",
              file4_name:
                uploadFilesArray.length > 3 ? uploadFilesArray[3].name : "",
              file5:
                uploadFilesArray.length > 4
                  ? await toBase64(uploadFilesArray[4])
                  : "",
              file5_name:
                uploadFilesArray.length > 4 ? uploadFilesArray[4].name : "",
              file6:
                uploadFilesArray.length > 5
                  ? await toBase64(uploadFilesArray[5])
                  : "",
              file6_name:
                uploadFilesArray.length > 5 ? uploadFilesArray[5].name : "",
              file7:
                uploadFilesArray.length > 6
                  ? await toBase64(uploadFilesArray[6])
                  : "",
              file7_name:
                uploadFilesArray.length > 6 ? uploadFilesArray[6].name : "",
              file8:
                uploadFilesArray.length > 7
                  ? await toBase64(uploadFilesArray[7])
                  : "",
              file8_name:
                uploadFilesArray.length > 7 ? uploadFilesArray[7].name : "",
            };

            addClientContact();

            var service = "";
            if (props.uData.role === "consultantTele") {
              service = "analizy_kppp";
            } else {
              service = "KPPP";
            }

            emailjs.send(service, "template_h43760d", templateParams).then(
              function (response) {
                if (props.mode === "sellTask") {
                  props.close();
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Wysłano",
                    text: "wiadomość do klienta",
                  }).then(async (result) => {
                    props.close();
                  });
                }
              },
              function (error) {
                MySwal.fire({
                  icon: "error",
                  title: "Błąd",
                  text: "nie wysłano wiadomości e-mail. Ponów operację!",
                }).then(async (result) => {
                  props.close();
                });
              }
            );
          }
        } else {
          MySwal.fire({
            icon: "error",
            title: "Wybierz",
            text: "szablon wiadomości",
          }).then(async (result) => {});
        }
      }
    } catch (err) {}
  };

  const addAttach = (e) => {
    var file = sellFiles.filter((el) => +el.id === +e.target.value)[0];
    fetch(file.link)
      .then((res) => res.blob())
      .then((blob) => {
        var fileX = new File([blob], file.name);
        uploadFilesArray.push(fileX);
      });
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const addAttachAnalysis = (link, name) => {
    const fileId = link
      .replaceAll("https://drive.google.com/uc?id=", "")
      .replaceAll("&export=download", "");
    function start() {
      gapi.client.init({
        apiKey: "AIzaSyAs4Nc5GwWyhK8tWohQYWg0S1AMkDGRK1Y",
        clientId: "118170724273208939177",
        scope: "https://www.googleapis.com/auth/drive",
      });

      gapi.client.load("drive", "v3").then(() => {
        try {
          gapi.client.drive.files
            .get({ fileId, alt: "media" })
            .then((response) => {
              const dataUrl = `data:${
                response.headers["Content-Type"]
              };base64,${btoa(response.body)}`;
              var file = dataURLtoFile(dataUrl, name);
              uploadFilesArray.push(file);
            })
            .catch((error) => {});
        } catch (error) {}
      });
    }

    gapi.load("client:auth2", start);
    setLoading(false);
  };

  return (
    <div
      style={{ width: "50vw", top: "10vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            style={{
              overflowY: "scroll",
              maxHeight: "65vh",
              scrollbarWidth: "auto",
            }}
            id="addPaymentIC"
            className="inputContainer"
          >
            <div className="inputBox">
              <div style={{ minWidth: "95%" }} className="inputCol_1">
                <label>
                  Wybierz szablon <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {!template ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {templates.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <div style={{ width: "95%", marginTop: "3vh" }}>
              <label>Temat wiadomości</label>
              <input
                type="text"
                id="signature"
                name="signature"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                }}
              />
            </div>
            <label style={{ marginTop: "2vh" }}>Wiadomość</label>
            <div
              style={{
                marginTop: "1vh",
                border: "1px solid black",
                borderRadius: "15px",
                width: "95%",
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
              />
            </div>
            <label style={{ marginTop: "2vh" }}>Załączniki</label>
            <input multiple={true} type="file" onChange={changeFiles} />
            {uploadFilesArray.length > 0 ? (
              <>
                <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                  <table
                    style={{ width: "95%", boxSizing: "border-box" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Plik</th>
                      <th></th>
                    </tr>
                    {uploadFilesArray.length > 0
                      ? uploadFilesArray.map((el, index) => (
                          <>
                            <tr>
                              <td
                                style={{
                                  width: "50%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <input
                                    id={"fn" + index}
                                    name={"fn" + index}
                                    style={{
                                      height: "2vh",
                                      marginTop: "0",
                                    }}
                                    type="text"
                                    value={inputs[index]}
                                    onChange={(e) =>
                                      setInputs((prev) => {
                                        return {
                                          ...prev,
                                          [index]: e.target.value,
                                        };
                                      })
                                    }
                                  />
                                  <button
                                    className="refreshButton"
                                    value={index}
                                    onClick={changeFileName}
                                  >
                                    zmień
                                  </button>
                                </div>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "40%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                  wordWrap: "anywhere",
                                }}
                              >
                                {el.name}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "10%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <button
                                  className="refreshButton"
                                  value={index}
                                  onClick={deleteTempFile}
                                >
                                  usuń
                                </button>
                              </td>
                            </tr>
                          </>
                        ))
                      : ""}
                  </table>
                </div>
              </>
            ) : (
              ""
            )}

            {sellFiles.length > 0 ? (
              <>
                <label style={{ marginTop: "2vh", marginBottom: "2vh" }}>
                  Pliki przypisane do kontaktu
                </label>
                <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                  <table
                    style={{ width: "95%", boxSizing: "border-box" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Plik</th>
                      <th></th>
                    </tr>
                    {sellFiles.length > 0
                      ? sellFiles.map((el, index) => (
                          <>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "40%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                  wordWrap: "anywhere",
                                }}
                              >
                                {el.name}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "10%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <button
                                  className="refreshButton"
                                  value={el.id}
                                  onClick={addAttach}
                                  style={{ fontSize: ".8vw" }}
                                >
                                  dodaj do załacznika
                                </button>
                              </td>
                            </tr>
                          </>
                        ))
                      : ""}
                  </table>
                </div>
              </>
            ) : (
              ""
            )}

            {analysis.length > 0 ? (
              <>
                <label style={{ marginTop: "2vh", marginBottom: "2vh" }}>
                  Analizy
                </label>
                <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                  <table
                    style={{ width: "95%", boxSizing: "border-box" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Plik</th>
                      <th></th>
                    </tr>
                    {analysis.length > 0
                      ? analysis.map((el, index) => (
                          <>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "40%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                  wordWrap: "anywhere",
                                }}
                              >
                                {el.addDate}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  width: "10%",
                                  padding: "5px 20px",
                                  height: "3vh",
                                }}
                              >
                                <button
                                  className="refreshButton"
                                  value={el.id}
                                  onClick={() => {
                                    setLoading(true);
                                    addAttachAnalysis(el.link, el.addDate);
                                  }}
                                  style={{ fontSize: ".8vw" }}
                                >
                                  dodaj do załacznika
                                </button>
                              </td>
                            </tr>
                          </>
                        ))
                      : ""}
                  </table>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={setStatusX}>
                Wyślij
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SendSellClientMail;
